// extracted by mini-css-extract-plugin
export default {"heading":"Glitter_heading__MGVCE","headingText":"Glitter_headingText__c+R6B","animate":"Glitter_animate__bjYnn"};